import type { ErpFieldDefinition } from '@schemas/api';

type ReviewErpField = Pick<ErpFieldDefinition, 'field_key' | 'value_scope' | 'supports_posting'>;

const REVIEW_HEADER_FIELD_KEYS = new Set(['payment_terms', 'department', 'location']);
const REVIEW_LINE_FIELD_KEYS = new Set(['customer_project', 'class', 'department', 'location']);
const HEADER_ONLY_LINE_FIELD_KEYS = new Set(['class', 'department', 'location']);

export const erpFieldKeyTail = (fieldKey?: string | null): string =>
  fieldKey && fieldKey.includes('.') ? fieldKey.split('.').slice(1).join('.') : fieldKey || '';

export const isReviewErpField = (field: ReviewErpField): boolean => {
  if (!field.supports_posting) {
    return false;
  }

  const fieldKeys = field.value_scope === 'header'
    ? REVIEW_HEADER_FIELD_KEYS
    : field.value_scope === 'line'
      ? REVIEW_LINE_FIELD_KEYS
      : undefined;

  return Boolean(fieldKeys?.has(erpFieldKeyTail(field.field_key)));
};

export const isReviewErpFieldKey = (fieldKey?: string | null): boolean => {
  const key = erpFieldKeyTail(fieldKey);
  return REVIEW_HEADER_FIELD_KEYS.has(key) || REVIEW_LINE_FIELD_KEYS.has(key);
};

export const getAvailableReviewErpFields = <T extends ReviewErpField & { id: string }>(
  fields: T[],
  enabledFieldIds: Set<string>,
): T[] => fields.filter((field) => isReviewErpField(field) && !enabledFieldIds.has(field.id));

export const isHeaderOnlyReviewErpField = (field: ReviewErpField): boolean =>
  field.value_scope === 'line' &&
  isReviewErpField(field) &&
  HEADER_ONLY_LINE_FIELD_KEYS.has(erpFieldKeyTail(field.field_key));
